import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/routerPages/Main'
import My from '@/routerPages/My'
import NotWechat from '@/routerPages/NotWechat'
import PayResult from '@/routerPages/PayResult'
import PayResultCancel from '@/routerPages/PayResultCancel'
import GoodsInfo from '@/components/GoodsInfo'
import Information from '@/components/Information'
import PayInfoList from '@/components/PayInfoList'
import PayInfo from '@/components/PayInfo'
import Index from "../routerPages/Index.vue";
import SignUpInfo from "../routerPages/info/SignUpInfo.vue";
import SignUpInfoList from "../routerPages/info/SignUpInfoList.vue";
import MyDelivery from "../routerPages/info/MyDelivery.vue";
import MyScore from "../routerPages/info/MyScore.vue";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        title: '凡星艺彩活动平台'
      }
    },
    {
      path: '/Main',
      name: 'Main',
      component: Main,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/My',
      name: 'My',
      component: My,
      meta: {
        title: '个人中心'
      }
    },
    {
      path: '/notWechat',
      name: 'NotWechat',
      component: NotWechat,
      meta: {
        title: '请在微信中打开此链接'
      }
    },
    {
      path: '/GoodsInfo',
      name: 'GoodsInfo',
      component: GoodsInfo,
      meta: {
        title: '活动详情'
      }
    },
    {
      path: '/Information',
      name: 'Information',
      component: Information,
      meta: {
        title: '填写报名信息'
      }
    },
    {
      path: '/PayInfoList',
      name: 'PayInfoList',
      component: PayInfoList,
      meta: {
        title: '支付列表'
      }
    },
    {
      path: '/PayInfo',
      name: 'PayInfo',
      component: PayInfo,
      meta: {
        title: '支付详情'
      }
    },
    {
      path: '/PayResult',
      name: 'PayResult',
      component: PayResult,
      meta: {
        title: '支付结果通知'
      }
    },
    {
      path: '/PayResultCancel',
      name: 'PayResultCancel',
      component: PayResultCancel,
      meta: {
        title: '支付结果通知'
      }
    },
    {
      path: '/SignUpInfo',
      name: 'SignUpInfo',
      component: SignUpInfo,
      meta: {
        title: '信息查询'
      }
    },
    {
      path: '/SignUpInfoList',
      name: 'SignUpInfoList',
      component: SignUpInfoList,
      meta: {
        title: '活动信息'
      }
    },
    {
      path: '/MyDelivery',
      name: 'MyDelivery',
      component: MyDelivery,
      meta: {
        title: '物流信息'
      }
    },
    {
      path: '/MyScore',
      name: 'MyScore',
      component: MyScore,
      meta: {
        title: '成绩查询'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js